import { contextFactory } from '@frontend/design-system';

type EditorNavigateContextState = {
  setOnBackClick: (fn: () => void) => void;
};

export const [EditorNavigateContext, useEditorNavigate] = contextFactory<EditorNavigateContextState>(
  'useEditorNavigate must be used within a BulkMessagePage'
);
